var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2633_7620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.16992,
    width: 54,
    height: 54,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.66992,
    width: 53,
    height: 53,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_7620)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4822 31.3086L20.2828 31.5928L20.3156 31.7106C20.5316 32.4848 20.8404 33.2299 21.2353 33.9299L21.2955 34.0365L20.2233 35.5121C20.1436 35.6223 20.1058 35.7572 20.1164 35.8927C20.1271 36.0283 20.1856 36.1556 20.2815 36.252L22.748 38.7185C22.8444 38.8144 22.9718 38.8728 23.1073 38.8834C23.2429 38.894 23.3778 38.8561 23.4879 38.7764L24.9627 37.7043L25.0692 37.7643C25.7695 38.159 26.5149 38.4679 27.2891 38.6844L27.4069 38.7172L27.6913 40.5177C27.7126 40.6521 27.7812 40.7745 27.8846 40.8629C27.9881 40.9513 28.1197 40.9999 28.2557 41H31.7438C31.8799 41 32.0115 40.9515 32.115 40.8631C32.2184 40.7747 32.2869 40.6522 32.3081 40.5177L32.5926 38.7169L32.7105 38.684C33.4847 38.4681 34.2298 38.1593 34.9298 37.7644L35.0364 37.7043L36.5112 38.7764C36.6215 38.8562 36.7565 38.8941 36.8922 38.8835C37.0278 38.8729 37.1553 38.8145 37.2518 38.7186L39.7184 36.252C39.8142 36.1556 39.8726 36.0282 39.8832 35.8927C39.8938 35.7572 39.8559 35.6223 39.7762 35.5121L38.7037 34.0365L38.7639 33.9299C39.1593 33.2302 39.4682 32.4851 39.6839 31.7108L39.7167 31.5928L41.5172 31.3087C41.6517 31.2875 41.7743 31.2191 41.8628 31.1156C41.9513 31.0121 42 30.8805 42 30.7443V27.2557C42 27.1196 41.9514 26.9879 41.8628 26.8844C41.7743 26.7809 41.6518 26.7125 41.5172 26.6914L39.7167 26.4073L39.6839 26.2894C39.4679 25.5151 39.159 24.7698 38.7639 24.0697L38.7037 23.9631L39.7762 22.4879C39.8559 22.3778 39.8938 22.2429 39.8832 22.1074C39.8726 21.9718 39.8142 21.8445 39.7184 21.748L37.2518 19.2815C37.1553 19.1856 37.0278 19.1271 36.8921 19.1165C36.7565 19.1059 36.6215 19.1439 36.5112 19.2237L35.0366 20.2953L34.93 20.2352C34.2301 19.8403 33.4849 19.5316 32.7107 19.3159L32.5928 19.283L32.3083 17.4821C32.2871 17.3477 32.2186 17.2252 32.1151 17.1368C32.0115 17.0484 31.8799 16.9999 31.7438 17H28.2557C28.1196 17 27.988 17.0486 27.8846 17.137C27.7811 17.2254 27.7126 17.3478 27.6913 17.4823L27.4069 19.2832L27.2889 19.316C26.5146 19.5319 25.7693 19.8406 25.0692 20.2354L24.9627 20.2954L23.4879 19.2237C23.3778 19.1441 23.2429 19.1062 23.1074 19.1167C22.9719 19.1273 22.8445 19.1857 22.748 19.2815L20.2815 21.748C20.1856 21.8444 20.1271 21.9717 20.1164 22.1073C20.1058 22.2428 20.1436 22.3777 20.2233 22.4879L21.2953 23.9631L21.2352 24.0696C20.8404 24.7698 20.5316 25.5151 20.3156 26.2894L20.2828 26.4073L18.4823 26.6914C18.3478 26.7125 18.2253 26.781 18.1369 26.8845C18.0485 26.988 17.9999 27.1196 18 27.2557V30.7443C18 30.8804 18.0485 31.012 18.1369 31.1154C18.2253 31.2189 18.3478 31.2874 18.4822 31.3086ZM32.8768 29.1093C32.8959 29.2586 32.9732 29.3943 33.0918 29.487C33.2105 29.5796 33.3609 29.6217 33.5104 29.6041C33.6599 29.5864 33.7964 29.5105 33.8903 29.3928C33.9841 29.2751 34.0277 29.1251 34.0116 28.9754L33.816 27.1848C33.7991 27.0343 33.7233 26.8965 33.6051 26.8017C33.4869 26.7069 33.336 26.6627 33.1854 26.6788L31.3952 26.8751C31.249 26.8905 31.1143 26.9616 31.0193 27.0738C30.9242 27.1859 30.876 27.3304 30.8848 27.4771C30.8935 27.6238 30.9585 27.7616 31.0662 27.8616C31.174 27.9616 31.3161 28.0163 31.4631 28.0142L31.8743 28.0095L29.8401 30.4657L27.7589 27.9527C27.7052 27.888 27.638 27.8359 27.5619 27.8001C27.4858 27.7643 27.4028 27.7458 27.3187 27.7458C27.2346 27.7458 27.1516 27.7643 27.0755 27.8001C26.9994 27.8359 26.9321 27.888 26.8785 27.9527L25.0947 30.1063L25.0357 29.6769C24.8662 28.4397 25.1644 27.1838 25.872 26.155C26.5796 25.1261 27.6456 24.3982 28.8615 24.1139C30.0774 23.8295 31.3556 24.0091 32.4461 24.6175C33.5366 25.2259 34.3608 26.2193 34.7575 27.4033C35.1542 28.5874 35.0947 29.8768 34.5909 31.0193C34.087 32.1619 33.1749 33.0753 32.0331 33.5808C30.8913 34.0863 29.602 34.1476 28.4174 33.7526C27.2328 33.3577 26.2382 32.5349 25.6282 31.4453L25.5642 31.3312L27.3184 29.2129L29.4002 31.7262C29.4537 31.791 29.5209 31.8432 29.597 31.8791C29.673 31.9149 29.756 31.9335 29.8401 31.9335C29.9241 31.9335 30.0072 31.9149 30.0832 31.8791C30.1592 31.8432 30.2264 31.791 30.2799 31.7262L32.8768 28.591V29.1094L32.8768 29.1093ZM30 35.1528C26.6074 35.1528 23.8469 32.3926 23.8469 29C23.8469 25.6074 26.6073 22.8472 30 22.8472C33.3927 22.8472 36.1528 25.6074 36.1528 29C36.1528 32.3926 33.3924 35.1528 30 35.1528Z",
    fill: "url(#paint0_linear_2633_7620)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2633_7620",
    x: 0,
    y: 0.169922,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2633_7620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2633_7620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7620",
    x1: 38.9125,
    y1: 48.9464,
    x2: 9.95847,
    y2: 37.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_7620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.e7f08295e6ec62251d135bc341416326.svg";
export { ForwardRef as ReactComponent };